import React from 'react';
import ReactDOM from 'react-dom';
import '../main.css';
import IslandApp from './IslandApp';
import { MetaMaskProvider } from '../metamask';
import { SceneProvider } from './context';
import { KeyboardProvider } from './keyboard-context';
import { SocketProvider } from './socketio';


ReactDOM.render(
  <React.StrictMode>
    <SocketProvider>
      <MetaMaskProvider>
        <SceneProvider>
          <KeyboardProvider>
            <IslandApp />
          </KeyboardProvider>
        </SceneProvider>
      </MetaMaskProvider>
    </SocketProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

